module.exports = __webpack_public_path__ + "static/hut-doodle-06ba8599591d233344167844d7930edf.jpg";